import { render, staticRenderFns } from "./LoadingSplash.vue?vue&type=template&id=96ddcec8&scoped=true&"
import script from "./LoadingSplash.vue?vue&type=script&lang=ts&"
export * from "./LoadingSplash.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingSplash.vue?vue&type=style&index=0&id=96ddcec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ddcec8",
  null
  
)

export default component.exports